module.exports = __webpack_public_path__ + "img/banner_desktop.82bb2589.png";